export const cfaLightThemeBuiCss = `
:root, body[data-theme-mode='light'] {
  --cfa-font-size-base: 14px;
  --bui-font-size-1: 1.3rem;
  --bui-font-size-2: 1rem;
  --bui-font-size-3: 0.95rem;
  --bui-font-regular: Apercu;
  --bui-font-weight-regular: 400;
  --bui-font-weight-bold: 700;
  --bui-black: #000;
  --bui-white: #fff;
  --bui-fg-primary: #37424aff";
  --bui-fg-secondary: #6E6E6E;
  --bui-fg-disabled: #a7acafff;
  --bui-fg-solid: #ffffffff;
  --bui-fg-solid-disabled: #a7acafff;
  --bui-fg-danger: #b6072fff;
  --bui-fg-warning: #fbc111ff;
  --bui-fg-success: #077e4cff;
  --bui-fg-info: #006b9aff;
  --bui-fg-danger-on-bg: rgba(127, 4, 32, 1);
  --bui-fg-warning-on-bg: rgba(175, 135, 11, 1);
  --bui-fg-success-on-bg: rgba(4, 88, 53, 1);
  --bui-fg-info-on-bg: rgba(0, 74, 107, 1);
  --bui-bg-app: #ffffffff;
  --bui-bg-neutral-1: #f2f3f4ff;
  --bui-bg-neutral-2: #ffffffff;
  --bui-bg-neutral-3: #ffffffff;
  --bui-bg-solid: #004f71ff;
  --bui-bg-solid-hover: rgb(0, 67, 96);
  --bui-bg-solid-pressed: rgba(0, 55, 79, 1);
  --bui-bg-solid-disabled: rgba(0, 0, 0, 0.12);
  --bui-bg-danger: rgba(196, 56, 88, 1);
  --bui-bg-warning: rgba(251, 205, 64, 1);
  --bui-bg-success: rgba(56, 151, 111, 1);
  --bui-bg-info: rgba(51, 136, 174, 1);
  --bui-border-danger: #b6072fff;
  --bui-border-warning: #fbc111ff;
  --bui-border-success: #077e4cff;
  --bui-border-info: #006b9aff;
  --bui-border-2: #f2f3f4ff;
  --bui-ring: #FFFBCC;
  .bui-PluginHeader {
    display: none;
  }
  .bui-PluginHeaderToolbarWrapper {
    border-bottom: none;
  }
}`;